import React, { FC, useEffect } from "react";
import { Button, Table, Input, Tooltip } from "antd";
import { YhBox } from "@/components/YhBox";
import { useOutputDetailsModel } from "./outputDetailsModel";
import { globalPrompt } from "@/components/message";
import { ColumnsType } from "antd/es/table";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { DetailType } from "@/types/ScmEnums";
import { IDetailList } from "../../stockEntryService"
import { formatNum } from "@/utils/utils";
import { EditableCell, EditableRow } from "@/components/YHEditTable/editTable";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const { detailLookList, detailLookForm } = useOutputDetailsModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale, warehouseList } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const desc: IDescription[] = [
        {
            label: Locale["Stock-out Qty"],//"入库数量",
            value: detailLookForm.inTotal ?? 0,
            color: DescriptionColorEnum.red
        }
    ]

    const columns = [
        {
            // title: '序号',
            title: Locale["SN"],
            width: 80,
            render: (t: any, r: any, i: number) => i + 1
        }, {
            // title: '商品编码',
            title: Locale["Material Code"],
            width: 180,
            dataIndex: 'materialCode',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '商品名称',
            title: Locale["Material Name"],
            width: 180,
            dataIndex: 'materialName',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '商品名称-英文',
            title: Locale['Material Name En'],
            width: 160,
            dataIndex: 'materialNameEn',     
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,             
        }, {
            // title: '数量',
            title: Locale["Qty"],
            width: 160,
            dataIndex: 'num',
        }, {
            // title: '单价',
            title: Locale["Unit Price"],
            width: 160,
            dataIndex: 'price',
        }, {
            // title: '折扣',
            title: Locale["Discount Rate"],
            width: 160,
            dataIndex: 'discountRate',
        }, {
            // title: '合计',
            title: Locale["Total"],
            width: 160,
            dataIndex: 'amount',
        }, {
            // title: '仓库',
            title: Locale["Warehouse"],
            width: 160,
            dataIndex: 'warehouseName',
        }, {
            // title: '货位',
            title: Locale["Shelf"],
            width: 120,
            dataIndex: 'shelfCode',
        }
    ];
    return (
        <YhBox title={<></>} descriptions={desc}>
            <Table
                rowKey={record => record.id as string}
                columns={columns as ColumnsType<IDetailList>}
                dataSource={detailLookList as IDetailList[]}
                pagination={false}
                scroll={{ x: 'max-content', y: 290 }}
            />
        </YhBox>
    )
}